import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import LoadingScreen from '../components/LoadingScreen';

function Home() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'DevWing: Elevating aviation software development through powerful insights';
    
    // Check if the user is authenticated
    const isAuthenticated = !!localStorage.getItem('jwt');
    if (isAuthenticated) {
      navigate('/dashboard');
    }
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Layout>
      <div className="mt-12 flex flex-col items-center justify-center">
        <img src="/images/logo.png" alt="DevWing Logo" className="h-16 w-16 mb-8" />
        <h1 className="text-2xl font-bold text-center mb-2">Welcome to DevWing</h1>
        <div className="max-w-prose mb-8">Elevating aviation software development through powerful insights</div>
        <button
          onClick={() => navigate('/login')}
          className="mt-4 px-6 py-2 bg-sky-500 text-white rounded-md hover:bg-sky-600 transition duration-300"
        >
          Login
        </button>
      </div>
    </Layout>
  );
}

export default Home;
